var map = {
	"./de-DE.js": 6505,
	"./en-US.js": 4750,
	"./es-ES.js": 627,
	"./fr-FR.js": 8831,
	"./index.js": 1340,
	"./it-IT.js": 7897,
	"./ja-JP.js": 2990,
	"./ko-KR.js": 4360,
	"./pt-BR.js": 267,
	"./ru-RU.js": 3365,
	"./zh-CN.js": 852
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5886;
module.exports = webpackAsyncContext;